import { CMSEnum } from './../../../models/enums/CMS/CMSEnum';
import { SocialMediaEnum } from './../../../models/enums/CMS/SocialMediaEnum';
import { CmsService } from './../../../services/cms.service';
import { HeaderService } from './../../../services/header.service';
import { Component, OnInit } from '@angular/core';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import {  faInstagram } from '@fortawesome/free-brands-svg-icons';
import {  faTwitter } from '@fortawesome/free-brands-svg-icons';
import {  faLinkedin } from '@fortawesome/free-brands-svg-icons';
import {  faGoogle } from '@fortawesome/free-brands-svg-icons';
import { faComments } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  faFacebookF= faFacebookF;
  faInstagram=faInstagram;
  faTwitter=faTwitter;
  faLinkedin=faLinkedin;
  faGoogle=faGoogle;
  faComments=faComments;
  year;
  AboutUsContent;
  ServiceTermsContent;
  FAQContent;
  PrivacyPolicyContent;
  facbookURL;
  instagramURL;
  twitterURL;
  linkedinURL;
  googleURL;


  SocialLinks

  constructor( private service: HeaderService,private cmsService: CmsService) {

    this.year = new Date().getFullYear();

   }

   ngOnInit(): void {
    this.cmsService.contentModel.subscribe(res =>{
      if(res!=null&&res.contents!=null){
        this.SocialLinks=res.contents.filter(a => a.sectionID==CMSEnum.SocialMedia);
        this.AboutUsContent=res.contents.filter(a => a.sectionID==CMSEnum.AboutUs)[0];
        this.ServiceTermsContent=res.contents.filter(a => a.sectionID==CMSEnum.ServiceTerms)[0];
        this.FAQContent=res.contents.filter(a => a.sectionID==CMSEnum.FAQs)[0];
        this.PrivacyPolicyContent=res.contents.filter(a => a.sectionID==CMSEnum.PrivacyPolicy)[0];


        this.facbookURL=res.contents.filter(a => a.sectionID==CMSEnum.SocialMedia && a.order==SocialMediaEnum.Facebook)[0];
        this.instagramURL=res.contents.filter(a => a.sectionID==CMSEnum.SocialMedia &&  a.order==SocialMediaEnum.Instagram)[0];
        this.twitterURL=res.contents.filter(a => a.sectionID==CMSEnum.SocialMedia &&  a.order==SocialMediaEnum.Twitter)[0];
        this.linkedinURL=res.contents.filter(a => a.sectionID==CMSEnum.SocialMedia &&  a.order==SocialMediaEnum.LinkedIn)[0];
        this.googleURL=res.contents.filter(a => a.sectionID==CMSEnum.SocialMedia &&  a.order==SocialMediaEnum.Google)[0];
      }
    })
  }

}

